function CircleCheckIcon({ className = '' }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`text-validation-success transition-colors duration-300 ${className}`}
    >
      <circle
        cx="9"
        cy="9"
        r="8.5"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      <path
        d="M6.75 9L8.25 10.5L11.25 7.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CircleCheckIcon;
